import React, { useState } from "react";
import Button from "antd-button-color";
import Logo from "../../components/Logo/Logo";
import GlobalSearchInput from "../StatefulComponents/GlobalSearch/GlobalSearch";
import Notifications from "../StatefulComponents/Notifications/Notifications";
import UserAccountButton from "../StatefulComponents/UserAccountButton/UserAccountButton";
import Styles from "./Header.scss";
import { AppManager } from "../../manager";
import { RootState } from "../../redux/reducers";
import { useSelector } from "react-redux";
import { HOME_ROUTE, ORGANIZATIONS_ROUTE } from "../../constants/appRoutes";
import { useModelEventWatcher } from "../../hooks/modelHook";
import { DealerGroup } from "../../models/Organization/DealerGroup";
import { TFullDealerGroupAttr } from "../../models/Organization/Types";

/**
 * Renders the default app header
 */
export const AppHeader = () => {
    const isAuthenticated = useSelector<RootState, boolean>((state) => state.auth.isAuthenticated);
    const hasActiveOrg = useSelector<RootState, boolean>((state) => Boolean(state.orgs.activeOrg));
    const hasAuthorizedOrgs = useSelector<RootState, boolean>((state) => Boolean(state.orgs.orgs.length));
    const isHomeRoute = AppManager.route.CURRENT_ROUTE === HOME_ROUTE;
    const isOrgsRoute = AppManager.route.CURRENT_ROUTE === ORGANIZATIONS_ROUTE;
    const activeDgroup = useSelector<RootState, DealerGroup | undefined>((state) => state.dealerGroup.activeDealerGroup);
    const [dGroupAttr] = useModelEventWatcher(activeDgroup, "ATTRIBUTES_UPDATED", activeDgroup?.data.attrs as TFullDealerGroupAttr | undefined);
    return (
        <div className={Styles.Container}>
            <div className={Styles.LogoWrapper}>
                <Logo type="with-text-right" />
            </div>
            <div className={Styles.HeaderActions}>
                {isAuthenticated && hasActiveOrg && activeDgroup && dGroupAttr?.subscription?.status === "live" && (
                    <div className={Styles.GlobalSearch}>
                        <GlobalSearchInput />
                    </div>
                )}
                {isAuthenticated && (
                    <div className={Styles.OrgsButtonWrapper}>
                        <Button
                            type="info"
                            onClick={AppManager.route.gotoAuthorizedOrganizations}
                            disabled={!hasAuthorizedOrgs || isHomeRoute || isOrgsRoute}
                        >
                            Organizations
                        </Button>
                    </div>
                )}
                <div className={Styles.Notifications}>
                    <Notifications />
                </div>
                <div className={Styles.UserAccountBtn}>
                    <UserAccountButton />
                </div>
            </div>
        </div>
    );
};

export default AppHeader;
